import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import * as ReactIntl from "react-intl"
import Card from "../../../card"
import * as CashFlowDomain from "../../../../domain/sfp/cash-flow-domain"
import * as LoanDomain from "../../../../domain/sfp/loan-domain"
import * as ProspectiveDomain from "../../../../domain/sfp/prospective-domain"
import * as ScenarioDomain from "../../../../domain/sfp/scenario-domain"
import * as PpiDomain from "../../../../domain/sfp/ppi-domain"
import * as ResultDomain from "../../../../domain/sfp/result-domain"
import * as Model from "../../../../model"
import { FooterItem, LinkFooterItem } from "../../../card/footer-item"
import * as Tabledefinition from "../../../scenarii/detail/table-definition"

import "./style.scss"
import Operations from "../../../scenarii/common/operations"

class GoalsCard extends React.Component<Props> {
	private balancePpiAmounts: number[] = []
	private scenario: Model.Scenario
	private grossCashFlows: (number | null)[] = []
	private prospectiveYears: number[] = []
	private regularDecompositions: Model.LoanDecomposition[] = []
	private reimbursedCapitals: (number | null)[] = []
	private remainingCapitals: (number | null)[] = []
	private retrospectiveYears: number[] = []
	private simulatedDecompositions: Model.LoanDecomposition[] = []
	private wholeDecompositions: Model.LoanDecomposition[] = []

	constructor(props: Readonly<Props>) {
		super(props)

		this.scenario = ScenarioDomain.findValidatedScenario(
			props.scenarii, props.year)

		this.updateRetrospectiveYears()
		this.updateProspectiveYears()

		this.updateBalancePpi(props)
		this.updateLoanDecompositions(props)
		this.updateGrossCashFlows(props)
		this.updateReimbursedCapitals()
		this.updateRemainingCapitals()
	}

	componentWillReceiveProps(nextProps: Readonly<Props>): void {
		if (!nextProps.localAuthority) return
		if (this.props.scenarii !== nextProps.scenarii)
			this.scenario = ScenarioDomain.findValidatedScenario(
				nextProps.scenarii, nextProps.year)
		this.updateBalancePpi(nextProps)
		this.updateLoanDecompositions(nextProps)
		this.updateGrossCashFlows(nextProps)
		this.updateReimbursedCapitals()
		this.updateRemainingCapitals()
	}

	render() {
		const localAuthority = this.props.localAuthority
		const maximumDebtRefund = formatMaxDebtRefund(localAuthority)
		const maximumDeleveragingYears = formatMaxDeleveragingYears(localAuthority)
		const minimumGrossCashFlow = formatMinGrossCashFlow(localAuthority)
		const footerItems: FooterItem[] = this.getFooterItems(this.props)		

		return (
			<div>
				<Card
			className="card-custom"
			title="📊 Chiffres clés"
			footerItems={footerItems}>
				<div className="table-chiffres-cle">
					<table>
						<thead>
							<tr>
								<th className="label-cell">Année</th>
								<th className="label-cell">CAF brute</th>
								<th className="label-cell">Désendettement années CAF</th>
								<th className="label-cell">% remboursement de la dette CAF</th>
								<th className="label-cell">Équilibre PPI</th>
							</tr>
						</thead>

						<tbody>
							{this.retrospectiveYears.map((y, i) => (
								<tr key={`retro-${i}`}>
									<td>{y}</td>
									{this.renderGrossCashFlowCell(i)}
									{this.renderCashFlowDeleveragingYearsCell(i)}
									{this.renderDebtRefundCell(i)}
									{this.renderPpiBalanceCell(i)}
								</tr>
							))}
							{this.prospectiveYears.map((y, i) => (
								<tr key={`pro-${i}`}>
									<td>{y}</td>
									{this.renderGrossCashFlowCell(i + this.retrospectiveYears.length)}
									{this.renderCashFlowDeleveragingYearsCell(i + this.retrospectiveYears.length)}	
									{this.renderDebtRefundCell(i + this.retrospectiveYears.length)}	
									{this.renderPpiBalanceCell(i + this.retrospectiveYears.length)}							
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div className="container-objectif">
					<div className="title">
						Objectifs
					</div>
					<div className="bloc-chiffre">
						<p className="chiffre-objectif">{minimumGrossCashFlow}</p>
						<p>CAF brute minimum</p>
					</div>
					<div className="bloc-chiffre">
						<p className="chiffre-objectif">{maximumDeleveragingYears}</p>
						<p>Nombre d'année de désendettement maximum</p>
					</div>
					<div className="bloc-chiffre">
						<p className="chiffre-objectif">{maximumDebtRefund}</p>
						<p>% maximum de remboursement de la dette sur CAF</p>
					</div>

				</div>
			</Card>

		</div>
		);
	}

	private getFooterItems(props: Readonly<Props>): FooterItem[] {
		const label = "Modifier les valeurs"
		const footerItem: LinkFooterItem = {
			content: label,
			disabled: false,
			title: label,
			to: ""
		}

		if (props.localAuthority) {
			footerItem.disabled = false
			footerItem.to = `/${props.localAuthority.slug}/suivi-personnalise/politique`
		}

		return [footerItem]
	}


	private renderCashFlowDeleveragingYearsCell(index: number): React.ReactNode {

		if (this.props.loading) return this.renderLoadingCell(`desendettement-${index}`);

		const cashFlow = this.grossCashFlows[index];
		
		if (!cashFlow) {
			return this.renderEmptyCell(`desendettement-${index}`);
		}
	
		const cashFlowDeleveragingYears = CashFlowDomain.calculateCashFlowDeleveragingYears(cashFlow, this.remainingCapitals[index]);
	
		return (
			<td key={`desendettement-${index}`}>
				{CashFlowDomain.formatDeleveragingYears(cashFlowDeleveragingYears)}
			</td>
		);
	}

	private renderDebtRefundCell(index: number): React.ReactNode {
		
		if (this.props.loading) return this.renderLoadingCell(`remboursement-${index}`);

		const cashFlow = this.grossCashFlows[index];
		const debtRefund = CashFlowDomain.calculateDebtRefundPercentage(
			cashFlow, this.reimbursedCapitals[index]
		);
	
		return (
			<td key={`remboursement-${index}`}>
				{debtRefund != null
					? <ReactIntl.FormattedNumber value={debtRefund} style="percent" />
					: ""}
			</td>
		);
	}

	private renderEmptyCell(key: React.ReactText): React.ReactNode {
		return <td key={key}></td>
	}

	private renderGrossCashFlowCell(index: number): React.ReactNode {

		if (this.props.loading) return this.renderLoadingCell(`caf-${index}`);

		const cashFlow = this.grossCashFlows[index];
	
		if (cashFlow === null) {
			return this.renderEmptyCell(`caf-${index}`);
		}
	
		return (
			<td key={`caf-${index}`}>
				<ReactIntl.FormattedNumber
					currency="EUR"
					style="currency"
					value={cashFlow}
				/>
			</td>
		);
	}	

	private renderLoadingCell(key: React.ReactText): React.ReactNode {
		return <td key={key}>
			<FontAwesomeIcon icon="spinner" pulse />
		</td>
	}

	private renderPpiBalanceCell(index: number): React.ReactNode {

		if (this.props.loading) return this.renderLoadingCell(`equilibre-${index}`);

		const cashFlow = this.grossCashFlows[index];		
		
		if (cashFlow === null) return this.renderEmptyCell(`equilibre-${index}`);
	
		const balancePpi = this.balancePpiAmounts[index];
	
		return (
			<td key={`equilibre-${index}`}>
				<ReactIntl.FormattedNumber
					currency="EUR"
					style="currency"
					value={balancePpi} />
			</td>
		);
	}

	private updateBalancePpi(props: Readonly<Props>): void {
		const retroBalancePpi = this.retrospectiveYears.map(year => {
			if (!(props.ppi && this.scenario)) return 0
			const observationsInvest = props.localAuthority.observations.filter(o => props.localAuthority.accounts.some(a => a.account.id === o.account.id));
			const balancePpi = ResultDomain.getCumulativeInvestmentResultAmount(
				observationsInvest,
				props.localAuthority.results, 
				props.localAuthority.rests,
				year
			)
			return balancePpi
		})
		
		const proBalancePpi = this.prospectiveYears.map(year => {
			if (!(props.ppi && this.scenario)) return 0
			const ppiYearLoans = PpiDomain.getPpiYearLoans(LoanDomain.getLoansWithDecomposition(props.loans), props.ppi)
			const balancePpi = ResultDomain.getProspectiveCalculatedOperationResultAmountForAYear(
				props.localAuthority,
				ppiYearLoans,
				props.ppi,
				this.scenario,
				year
			)
			return balancePpi

		})

		this.balancePpiAmounts = [ ...retroBalancePpi, ...proBalancePpi]
	}

	private updateGrossCashFlows(props: Readonly<Props>): void {
		const retroGrossCashFlows = this.retrospectiveYears.map(year => {
			if (!props.localAuthority) return;
			const observations = props.localAuthority.observations.filter(o => props.localAuthority.accounts.some(a => a.account.id === o.account.id));
			return CashFlowDomain.getGrossCashFlowAmount(
				observations, year)
		})

		const proGrossCashFlows = this.prospectiveYears.map(year => {
			if (!(props.ppi && this.scenario)) return null
			const operations: Operations = new Operations(this.scenario, props.ppi, props.localAuthority);
			const ppiYearLoans = PpiDomain.getPpiYearLoans(LoanDomain.getLoansWithDecomposition(props.loans), props.ppi)
			return Tabledefinition._aggregateCAFBrute("prospective", year, props.localAuthority, operations, null, [], ppiYearLoans);
		})

		this.grossCashFlows = [...retroGrossCashFlows, ...proGrossCashFlows]
	}

	private updateLoanDecompositions(props: Readonly<Props>): void {
		this.regularDecompositions = []
		this.simulatedDecompositions = []
		this.wholeDecompositions = []

		if (props.loans) {
			props.loans.forEach(loan => {
				this.wholeDecompositions.push(LoanDomain.getDecomposition(loan))

				if (loan.simulate)
					this.simulatedDecompositions.push(LoanDomain.getDecomposition(loan))
				else this.regularDecompositions.push(LoanDomain.getDecomposition(loan))
			})
		}
	}

	private updateReimbursedCapitals(): void {
		const retroCapitals = this.retrospectiveYears.map((y, i) => {
			return LoanDomain.getTotalYearReimbursedCapital(
				this.regularDecompositions, y)
		})

		const proCapitals = this.prospectiveYears.map((y, i) => {
			return LoanDomain.getTotalYearReimbursedCapital(
				this.wholeDecompositions, y)
		})

		this.reimbursedCapitals = [...retroCapitals, ...proCapitals]
	}

	private updateRemainingCapitals(): void {
		const retroCapitals = this.retrospectiveYears.map((y, i) => {
			return LoanDomain.getTotalYearRemainingCapital(
				this.regularDecompositions, y)
		})

		const proCapitals = this.prospectiveYears.map((y, i) => {
			return LoanDomain.getTotalYearRemainingCapital(
				this.wholeDecompositions, y)
		})

		this.remainingCapitals = [...retroCapitals, ...proCapitals]
	}

	private updateRetrospectiveYears(): void {
		const currentYear = (new Date()).getFullYear()

		for (let year = currentYear - 6; year < currentYear; year++)
			this.retrospectiveYears.push(year)
	}

	private updateProspectiveYears(): void {
		const currentYear = (new Date()).getFullYear()

		for (let year = currentYear; year <= currentYear + 4; year++)
			this.prospectiveYears.push(year)
	}
}

export default ReactIntl.injectIntl(GoalsCard)

export interface OwnProps {
	year: number
	loading: boolean
	loans: Model.Loan[]
	localAuthority: Model.LocalAuthority
	scenarii: Model.Scenario[]
	ppi: Model.Ppi
}

function formatMaxDebtRefund(
	localAuthority: Model.LocalAuthority
): React.ReactNode {
	return localAuthority && localAuthority.maximumDebtRefund
	? <ReactIntl.FormattedNumber
		style="percent"
		value={localAuthority.maximumDebtRefund} />
	: "NC"
}

function formatMaxDeleveragingYears(
	localAuthority: Model.LocalAuthority
): React.ReactNode {
	return localAuthority && localAuthority.maximumDeleveragingYears
	? <span>
			<ReactIntl.FormattedNumber
			value={localAuthority.maximumDeleveragingYears} />
			&nbsp;
			<ReactIntl.FormattedPlural
			one="an"
			other="ans"
			value={localAuthority.maximumDeleveragingYears}
			zero="année" />
		</span>
	: "NC"
}

function formatMinGrossCashFlow(
	localAuthority: Model.LocalAuthority
): React.ReactNode {
	return localAuthority && localAuthority.minimumGrossCashFlow
	? <ReactIntl.FormattedNumber
		currency="EUR"
		style="currency"
		value={localAuthority.minimumGrossCashFlow} />
	: "NC"
}

type Props = OwnProps & ReactIntl.InjectedIntlProps



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/goals-card/index.tsx